import { getUuid } from '@sibe/utilities/common';
import { HsLightStorage, HsPointLight, hsMakeDefaultLights } from '@sibe/hyperscene';

/** The default lights plus the pink point light several engine feature pages share. */
export function makePinkPointLights(): HsLightStorage {
  const pointLight: HsPointLight = new HsPointLight(getUuid(), 'PinkLight');
  pointLight.radius = 10;
  pointLight.color.set(1, 0, 0.5);
  pointLight.worldMatrix.setPosition([10, -5, 8]);
  return new HsLightStorage([...hsMakeDefaultLights(), pointLight]);
}
